import React, { useCallback } from 'react'
import { Radio, InputGroup } from '@wmgtech/legato'
import { useController } from 'react-hook-form'

import { IFormRadioProps } from './FormRadio.props'


export function FormRadio<T extends Record<string, any>>({
  grouping,
  list,
  fieldName,
  control,
  label,
}: IFormRadioProps<T> ) {
  const { field, fieldState: { error } } = useController<T>({
    name: fieldName,
    control
  })

  const handleChange = useCallback(
    (value) => () => { field.onChange(value) },
    [field],
  )

  return (
    <InputGroup
      label={label}
      validation={error && { message: error.message, type: 'error' }}
    >
      <div className={`lgt-radio-group lgt-radio-group--${grouping}`}>
        {
          list.map(({ value, ...el }) =>
            <Radio
              key={el.label}
              name={fieldName}
              {...el}
              checked={value === field.value}
              onChange={handleChange(value)}
            />
          )
        }
      </div>
    </InputGroup>
  )
}
